export const urlBuilder = (url, replacementObject) => {
  let modifiedURL = url;

  for (const key in replacementObject) {
    if (replacementObject.hasOwnProperty(key)) {
      modifiedURL = modifiedURL.replace(`:${key}`, replacementObject[key]);
    }
  }

  return modifiedURL;
};

export const encodeRelayState = (obj) => {
  const json = JSON.stringify(obj);
  return btoa(json) // base64 encode
    .replace(/\+/g, "-") // URL safe
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // strip padding
};

export const decodeRelayState = (str) => {
  // restore to normal base64
  let s = str.replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "="; // add padding if needed
  const json = atob(s); // base64 decode
  return JSON.parse(json);
};
